import { makeStyles } from '@material-ui/core';
import { calculateHeight, rem, px } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const tenderOptionsContainerStyles = makeStyles(() => ({
  background: {
    backgroundColor: themeColor.lightBackground,
  },
  containerSubHeaderLabel: {
    paddingBottom: calculateHeight(55).stringValue,
    fontWeight: 500,
  },
  buttonOptionsSection: {
    textAlign: 'left',
    paddingBottom: 0,
  },
  returnItemTitleHeaderInside: {
    textAlign: 'center',
    paddingBottom: 0,
  },
  orSection: {
    paddingTop: 20,
    paddingBottom: 10,
  },
  outerMostContainer: {
    width: '0',
  },
  containerAlignment: {
    alignSelf: 'flex-end',
    justifyContent: 'center',
  },
  selfAlign: {
    alignSelf: 'flex-end',
  },
  bottomActions: {
    alignSelf: 'flex-end',
    flex: 0,
  },
  buttonBack: {
    marginRight: 5,
  },
  buttonCancel: {
    marginLeft: 5,
  },
  outerFlexDesign: {
    flex: '1 1 0',
  },
  flexDesign: {
    flex: 1,
  },
  tenderExchangeBodyContainer: {
    justifyContent: 'space-between',
  },
  buttonAction: {
    justifyContent: 'start',
    marginBottom: rem(0.625),
    width: '100%',
    maxWidth: rem(12.5),
  },
  containerTitleSubheader: {
    alignItems: 'center',
  },
  returnItemTitleSubheader: {
    fontSize: rem(1.125),
    color: themeColor.modalTitle,
    paddingBottom: '2vh',
    paddingTop: '2vh',
  },
  subHeaderIcon: {
    color: '#4ca846',
    marginRight: rem(0.75),
    width: px(26),
  },
  containerForm: {
    paddingTop: rem(3.125),
    paddingRight: rem(8.875),
    paddingLeft: rem(8.875),
    '@media (aspect-ratio: 4/3)': {
      paddingRight: rem(4.438),
      paddingLeft: rem(4.438),
    },
  },
  textAmount: {
    color: '#5D6B72',
  },
  textAmountLabel: {
    color: themeColor.bigstone,
    fontSize: rem(1.125),
  },
  containerSubheader: {
    borderBottom: '1px solid #E5E5E5',
    paddingBottom: rem(1),
    marginBottom: rem(8.375),
  },
  containerTextAmount: {
    justifyContent: 'space-between',
  },
  containerAmountField: {
    justifyContent: 'space-around',
  },
  helper: {
    fontSize: rem(0.875),
  },
  inputAmount: {
    '& input': {
      textAlign: 'center',
      color: '#5D6B72',
    },
  },
}));
